import { GtmTrackingType } from '../constants';
import TrackingHelperInstance from './gtmTrackingHelper';

class GtmEventClickDelegator {
	constructor() {
		this.type = GtmTrackingType.EVENT_CLICK;
		this.preventDefault = true;
		this.openInNewTab = false;

		this.dataMapper = [
			{
				dataName: 'data-tracking-event-category',
				gtmKey: 'eventCategory',
			},
			{
				dataName: 'data-tracking-event-label',
				gtmKey: 'eventLabel',
			},
			{
				dataName: 'data-tracking-event-action',
				gtmKey: 'eventAction',
			},
			{
				dataName: 'data-tracking-event-value',
				gtmKey: 'eventValue',
			},
		];
	}

	getTrackingData(target) {
		this.target = target;

		return {
			event: 'eventClick',
			...TrackingHelperInstance.getRequiredDataAsObject(
				target,
				this.dataMapper,
			),
			eventCallback: !this.openInNewTab ? this.callback.bind(this) : null,
		};
	}

	callback() {
		if (this.target.href) window.location.assign(this.target.href);
	}
}

const GtmEventClickDelegatorInstance = new GtmEventClickDelegator();
export default GtmEventClickDelegatorInstance;

// for test purpose only
export const GtmEventClickDelegatorClass = GtmEventClickDelegator;
